export const IconTenant = ({ size = 24, color = 'currentColor' }) => {
  return (
    <svg fill={color} viewBox="0 0 512 512" width={size} height={size}>
      <path d="M470.948,481.583V0H41.052v481.583H15.209V512h25.842H184.52H327.48h143.468h25.842v-30.417H470.948z M240.791,481.583 h-25.855v-70.117h25.855V481.583z M297.063,481.583h-25.855v-70.117h25.855V481.583z M440.531,481.583H327.48V381.049H184.52 v100.534H71.469V30.417h369.062V481.583z" />
      <rect x="100.114" y="56.779" width="30.417" height="35.821" />
      <rect x="156.386" y="56.779" width="30.417" height="35.821" />
      <rect x="212.657" y="56.779" width="30.417" height="35.821" />
      <rect x="100.114" y="120.32" width="30.417" height="35.821" />
      <rect x="156.386" y="120.32" width="30.417" height="35.821" />
      <rect x="212.657" y="120.32" width="30.417" height="35.821" />
      <rect x="268.929" y="56.779" width="30.417" height="35.821" />
      <rect x="325.201" y="56.779" width="30.417" height="35.821" />
      <rect x="268.929" y="120.32" width="30.417" height="35.821" />
      <rect x="325.201" y="120.32" width="30.417" height="35.821" />
      <rect x="381.473" y="56.779" width="30.417" height="35.821" />
      <rect x="381.473" y="120.32" width="30.417" height="35.821" />
      <rect x="100.114" y="183.852" width="30.417" height="35.821" />
      <rect x="156.386" y="183.852" width="30.417" height="35.821" />
      <rect x="212.657" y="183.852" width="30.417" height="35.821" />
      <rect x="268.929" y="183.852" width="30.417" height="35.821" />
      <rect x="325.201" y="183.852" width="30.417" height="35.821" />
      <rect x="381.473" y="183.852" width="30.417" height="35.821" />
      <rect x="100.114" y="247.393" width="30.417" height="35.821" />
      <rect x="156.386" y="247.393" width="30.417" height="35.821" />
      <rect x="212.657" y="247.393" width="30.417" height="35.821" />
      <rect x="268.929" y="247.393" width="30.417" height="35.821" />
      <rect x="325.201" y="247.393" width="30.417" height="35.821" />
      <rect x="381.473" y="247.393" width="30.417" height="35.821" />
      <rect x="100.114" y="310.935" width="30.417" height="35.821" />
      <rect x="156.386" y="310.935" width="30.417" height="35.821" />
      <rect x="212.657" y="310.935" width="30.417" height="35.821" />
      <rect x="268.929" y="310.935" width="30.417" height="35.821" />
      <rect x="325.201" y="310.935" width="30.417" height="35.821" />
      <rect x="381.473" y="310.935" width="30.417" height="35.821" />
    </svg>
  );
};
